export default (theme) => ({
    root: {},
    icon: {
        padding: '16px 0',
        '& path': {
            transition: '.3s',
        },
        '&:hover path': {
            fill: theme.colors.primary.white,
        },
    },
});
